import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const projects = [
    {
      id: "1",
      title: "Hôtel de la Zoologie",
      description: "Description rapide du projet 1.",
      details: "Bordeaux France",
      images: ["/media/rfggrgg.avif"],
      descri: "text35",
      backgrounds: [
        "/media/projet/hotelZoologie/zz1.avif",
        "/media/projet/hotelZoologie/zz2.avif",
        "/media/rfggrgg.avif",
        "/media/projet/hotelZoologie/zz5.avif",
        "/media/projet/hotelZoologie/zz3.avif",
        "/media/projet/hotelZoologie/zz6.avif",
        "/media/projet/hotelZoologie/zz7.avif",
        "/media/projet/hotelZoologie/zz4.avif",
      ],
    },
    {
      id: "2",
      title: "Sébastopol",
      description: "Description rapide du projet 2.",
      details: "Paris France",
      images: ["/media/projet/sebasto/m18.jpg"],
      descri: "text73",
      backgrounds: [
        "/media/projet/sebasto/m1.jpg",
        "/media/projet/sebasto/m2.jpg",
        "/media/projet/sebasto/m3.jpg",
        "/media/projet/sebasto/m4.jpg",
        "/media/projet/sebasto/m10.jpg",
        "/media/projet/sebasto/m5.jpg",
        "/media/projet/sebasto/m9.jpg",
        "/media/projet/sebasto/m8.jpg",
        "/media/projet/sebasto/m7.jpg",
        "/media/projet/sebasto/m6.jpg",
        "/media/projet/sebasto/m11.jpg",
        "/media/projet/sebasto/m12.jpg",
        "/media/projet/sebasto/m13.jpg",
        "/media/projet/sebasto/m14.jpg",
        "/media/projet/sebasto/m15.jpg",
        "/media/projet/sebasto/m16.jpg",
        "/media/projet/sebasto/m17.jpg",
        "/media/projet/sebasto/m18.jpg",
        "/media/projet/sebasto/m19.jpg",
        "/media/projet/sebasto/m21.jpg",
        "/media/projet/sebasto/m22.jpg",
        "/media/projet/sebasto/m20.jpg",
      ],
    },
    {
      id: "3",
      title: "Maison à Saint-Tropez",
      description: "Description rapide du projet 3.",
      details: "Saint-Tropez France",
      images: ["/media/projet/stTropez/st2.jpg"],
      descri: "textstp",
      backgrounds: [
        "/media/projet/stTropez/st1.jpg",
        "/media/projet/stTropez/st2.jpg",
        "/media/projet/stTropez/st3.jpg",
        "/media/projet/stTropez/st17.jpg",
        "/media/projet/stTropez/st6.jpg",
        "/media/projet/stTropez/st12.jpg",
        "/media/projet/stTropez/st9.jpg",
        "/media/projet/stTropez/st8.jpg",
        "/media/projet/stTropez/st7.jpg",
        "/media/projet/stTropez/st10.jpg",
        "/media/projet/stTropez/st11.jpg",
        "/media/projet/stTropez/st16.jpg",
        "/media/projet/stTropez/st4.jpg",
        "/media/projet/stTropez/st14.jpg",
        "/media/projet/stTropez/st15.jpg",
        "/media/projet/stTropez/st5.jpg",
        "/media/projet/stTropez/st13.jpg",
      ],
    },
    {
      id: "4",
      title: "Maison à Comporta",
      description: "Description rapide du projet 4.",
      details: "Maison à Comporta au Portugal",
      images: ["/media/projet/comporta/co13.jpg"],
      descri: "textcomp",
      backgrounds: [
        "/media/projet/comporta/co1.jpg",
        "/media/projet/comporta/co2.jpg",
        "/media/projet/comporta/co6.jpg",
        "/media/projet/comporta/co4.jpg",
        "/media/projet/comporta/co3.jpg",
        "/media/projet/comporta/co5.jpg",
        "/media/projet/comporta/co10.jpg",
        "/media/projet/comporta/co8.jpg",
        "/media/projet/comporta/co9.jpg",
        "/media/projet/comporta/co7.jpg",
        "/media/projet/comporta/co11.jpg",
        "/media/projet/comporta/co12.jpg",
        "/media/projet/comporta/co13.jpg",
        "/media/projet/comporta/HHTRRT.jpg",
        "/media/projet/comporta/JJTT.jpg",
        "/media/projet/comporta/RGRGG.jpg",
        "/media/projet/comporta/GTTEEE.jpg",
        "/media/projet/comporta/AAZEED.jpg",
      ],
    },
    {
      id: "5",
      title: "Maison à Cabris",
      description: "Description rapide du projet 5.",
      details: "Maison à Cabris",
      images: ["/media/projet/Cabris/image6.jpg"],
      descri: "textcabris",
      backgrounds: [
        "/media/projet/Cabris/image1.jpg",
        "/media/projet/Cabris/image2.jpg",
        "/media/projet/Cabris/image3.jpg",
        "/media/projet/Cabris/image4.jpg",
        "/media/projet/Cabris/image5.jpg",
        "/media/projet/Cabris/image8.jpg",
        "/media/projet/Cabris/image6.jpg",
        "/media/projet/Cabris/image7.jpg",
        "/media/projet/Cabris/image9.jpg",
        "/media/projet/Cabris/image910.jpg",
        "/media/projet/Cabris/image911.jpg",
      ],
    },
    {
      id: "6",
      title: "Bar le Chaudron",
      description: "Description rapide du projet 6.",
      details: "Bar le Chaudron a La Rochelle",
      images: ["/media/projet/bar/barfini3.png"],
      descri: "textbar",
      backgrounds: [
        "/media/projet/bar/barfini3.png",
        "/media/projet/bar/bar2.png",
      ],
    },
    {
      id: "7",
      title: "Rue de la paix",
      description: "Description rapide du projet 7.",
      details: "Hotel Rue de la paix",
      images: ["/media/projet/paix/paix3.jpg"],
      descri: "textruepaix",
      backgrounds: [
        "/media/projet/paix/paix1.jpg",
        "/media/projet/paix/paix2.jpg",
        "/media/projet/paix/paix3.jpg",
      ],
    },
    {
      id: "8",
      title: "Domaine de Bagatelle",
      description: "Description rapide du projet 8.",
      details: "A Mareuil en Périgord",
      images: ["/media/projet/bagatelle/Sonna/IMG_9505.jpg"],
      descri: "textbagatelle",
      backgrounds: [
        "/media/projet/bagatelle/Sonna/IMG_9502.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9503.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9505.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9501.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9457.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9438.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9437.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9425.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9422.jpg",
        "/media/projet/bagatelle/Sonna/IMG_9436.jpg",

        "/media/projet/bagatelle/salledebaingrande/IMG_9512.jpeg",
        "/media/projet/bagatelle/salledebaingrande/IMG_9511.jpeg",
        "/media/projet/bagatelle/salledebaingrande/IMG_9362.jpeg",

        "/media/projet/bagatelle/toilette/IMG_9466.jpeg",

        "/media/projet/bagatelle/salledebain/IMG_9327.jpeg",
        "/media/projet/bagatelle/salledebain/IMG_9326.jpeg",

        "/media/projet/bagatelle/chambre/IMG_9374.jpg",
        "/media/projet/bagatelle/chambre/IMG_9367.jpg",
        "/media/projet/bagatelle/chambre/IMG_9386.jpg",

        "/media/projet/bagatelle/autresalledebain/IMG_9330.jpg",

        "/media/projet/bagatelle/petitepiece/IMG_9400.jpeg",
        "/media/projet/bagatelle/petitepiece/IMG_9403.jpeg",
      ],
    },
    {
      id: "9",
      title: "Hôtel 5 étoiles , cave",
      description: "Description rapide du projet 9.",
      details: "Champgane Thienot",
      images: ["/media/projet/thienot/salon.JPG"],
      descri: "textthienot",
      backgrounds: [
        "/media/projet/thienot/salon.JPG",
        "/media/projet/thienot/salon1.JPG",
        "/media/projet/thienot/salon2.JPG",
        "/media/projet/thienot/salon3.JPG",
        "/media/projet/thienot/couloire.JPG",
        "/media/projet/thienot/couloirmur.JPG",
        "/media/projet/thienot/mur.JPG",
        "/media/projet/thienot/mur2.JPG",
        "/media/projet/thienot/chambre.JPG",
        "/media/projet/thienot/chambre1.JPG",
        "/media/projet/thienot/salledebain4.JPG",
        "/media/projet/thienot/partie2/pt2.JPG",
        "/media/projet/thienot/partie2/pt3.JPG",
        "/media/projet/thienot/partie2/pt4.JPG",
        "/media/projet/thienot/partie2/pt5.JPG",
        "/media/projet/thienot/partie2/pt6.JPG",
        "/media/projet/thienot/partie2/pt7.JPG",
        "/media/projet/thienot/partie2/pt8.JPG",
        "/media/projet/thienot/partie2/pt9.JPG",
        "/media/projet/thienot/partie2/pt10.JPG",
        "/media/projet/thienot/partie2/pt11.JPG",
        "/media/projet/thienot/maquette.JPG",
      ],
    },
     {
      id: "10",
      title: "Camping Serignan",
      description: "Description rapide du projet 10.",
      details: "Camping Serignan",
      images: ["/media/projet/campingSerignan/19.jpg"],
      descri: "textserignan",
      backgrounds: [
        "/media/projet/campingSerignan/19.jpg",
        "/media/projet/campingSerignan/20.jpg",
        "/media/projet/campingSerignan/1.jpg",
        "/media/projet/campingSerignan/2.jpg",
        "/media/projet/campingSerignan/3.jpg",
        "/media/projet/campingSerignan/4.jpg",
        "/media/projet/campingSerignan/5.jpg",
        "/media/projet/campingSerignan/6.jpg",
        "/media/projet/campingSerignan/7.jpg",
        "/media/projet/campingSerignan/8.jpg",
        "/media/projet/campingSerignan/9.jpg",
        "/media/projet/campingSerignan/10.jpg",
        "/media/projet/campingSerignan/11.jpg",
        "/media/projet/campingSerignan/12.jpg",
        "/media/projet/campingSerignan/13.jpg",
        "/media/projet/campingSerignan/14.jpg",
        "/media/projet/campingSerignan/15.jpg",
        "/media/projet/campingSerignan/16.jpg",
        "/media/projet/campingSerignan/17.jpg",
      ],
    },
    {
      id: "11",
      title: "Château de Montmoreau",
      description: "Description rapide du projet 11.",
      details: "Château de Montmoreau",
      images: ["/media/projet/chateauMontmoreau/image.jpg"],
      descri: "textchateau",
      backgrounds: [
        "/media/projet/chateauMontmoreau/2.jpg",
        "/media/projet/chateauMontmoreau/image.jpg",
        "/media/projet/chateauMontmoreau/3.jpg",
      ],
    },
  ];

const ProjectDetails = () => {
  const { projectId } = useParams();
  const project = projects.find((p) => p.id === projectId);
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  
  if (!project) {
    return <h2>Projet non trouvé</h2>;
  }
  return (
    <div className="projet-detail-class" >
      <div data-aos="fade-up" className="projet-detail-class-title">
        {project.images.map((img, index) => (
            <img key={index} src={img} alt={`Projet ${project.id} - ${index + 1}`} />
        ))}
        <h1>{project.title}</h1>
        <p>{project.details}</p>
      </div>
      <div data-aos="fade-up" className="projet-content">
        <div className="text-descri">
          <p>{t(project.descri)}</p>
        </div>
        <div className="img-listt">

        {(project.backgrounds[0] || project.backgrounds[1]) && (
          <div className="lignall">
            {project.backgrounds[0] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[0]})` }}
               onClick={() => setSelectedImage(project.backgrounds[0])}>
              </div>
            )}
            {project.backgrounds[1] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[1]})` }}
              onClick={() => setSelectedImage(project.backgrounds[1])}>
              </div>
            )}
          </div>
        )}

        {(project.backgrounds[2] || project.backgrounds[3]) && (
          <div className="lignall">
            {project.backgrounds[2] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[2]})` }}
              onClick={() => setSelectedImage(project.backgrounds[2])}>
              </div>
            )}
            {project.backgrounds[3] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[3]})` }}
              onClick={() => setSelectedImage(project.backgrounds[3])}>
              </div>
            )}
          </div>
        )}

        {project.backgrounds[4] && (
          <div className="lign2">
              <div className="imgn2s"
              style={{ backgroundImage: `url(${project.backgrounds[4]})` }}
              onClick={() => setSelectedImage(project.backgrounds[4])}>
              </div>
          </div>
        )}

        {(project.backgrounds[5] || project.backgrounds[7]) && (
          <div className="lignall">
            {project.backgrounds[5] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[5]})` }}
              onClick={() => setSelectedImage(project.backgrounds[5])}>
              </div>
            )}
            {project.backgrounds[7] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[7]})` }}
              onClick={() => setSelectedImage(project.backgrounds[7])}>
              </div>
            )}
          </div>
        )}

        {project.backgrounds[6] && (
          <div className="lign2">
              <div className="imgn2s"
              style={{ backgroundImage: `url(${project.backgrounds[6]})` }}
              onClick={() => setSelectedImage(project.backgrounds[6])}>
              </div>
          </div>
        )}

        {(project.backgrounds[8] || project.backgrounds[9]) && (
          <div className="lignall">
            {project.backgrounds[8] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[8]})` }}
              onClick={() => setSelectedImage(project.backgrounds[8])}>
              </div>
            )}
            {project.backgrounds[9] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[9]})` }}
              onClick={() => setSelectedImage(project.backgrounds[9])}>
              </div>
            )}
          </div>
        )}

        {(project.backgrounds[10] || project.backgrounds[11]) && (
          <div className="lignall">
            {project.backgrounds[10] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[10]})` }}
              onClick={() => setSelectedImage(project.backgrounds[10])}>
              </div>
            )}
            {project.backgrounds[11] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[11]})` }}
              onClick={() => setSelectedImage(project.backgrounds[11])}>
              </div>
            )}
          </div>
        )}

        {project.backgrounds[12] && (
          <div className="lign2">
              <div className="imgn2s"
              style={{ backgroundImage: `url(${project.backgrounds[12]})` }}
              onClick={() => setSelectedImage(project.backgrounds[12])}>
              </div>
          </div>
        )}

        {(project.backgrounds[13] || project.backgrounds[14]) && (
          <div className="lignall">
            {project.backgrounds[13] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[13]})` }}
              onClick={() => setSelectedImage(project.backgrounds[13])}>
              </div>
            )}
            {project.backgrounds[14] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[14]})` }}
              onClick={() => setSelectedImage(project.backgrounds[14])}>
              </div>
            )}
          </div>
        )}

        {(project.backgrounds[15] || project.backgrounds[16]) && (
          <div className="lignall">
            {project.backgrounds[15] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[15]})` }}
              onClick={() => setSelectedImage(project.backgrounds[15])}>
              </div>
            )}
            {project.backgrounds[16] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[16]})` }}
              onClick={() => setSelectedImage(project.backgrounds[16])}>
              </div>
            )}
          </div>
        )}

        {(project.backgrounds[17] || project.backgrounds[18]) && (
          <div className="lignall">
            {project.backgrounds[17] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[17]})` }}
              onClick={() => setSelectedImage(project.backgrounds[17])}>
              </div>
            )}
            {project.backgrounds[18] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[18]})` }}
              onClick={() => setSelectedImage(project.backgrounds[18])}>
              </div>
            )}
          </div>
        )}

        {(project.backgrounds[19] || project.backgrounds[20]) && (
          <div className="lignall">
            {project.backgrounds[19] && (
              <div className="imgn1"
              style={{ backgroundImage: `url(${project.backgrounds[19]})` }}
              onClick={() => setSelectedImage(project.backgrounds[19])}>
              </div>
            )}
            {project.backgrounds[20] && (
              <div className="imgn2"
              style={{ backgroundImage: `url(${project.backgrounds[20]})` }}
              onClick={() => setSelectedImage(project.backgrounds[20])}>
              </div>
            )}
          </div>
        )}

        {project.backgrounds[21] && (
          <div className="lign2">
              <div className="imgn2s"
              style={{ backgroundImage: `url(${project.backgrounds[21]})` }}
              onClick={() => setSelectedImage(project.backgrounds[21])}>
              </div>
          </div>
        )}

        </div>
      </div>
      {selectedImage && (
  <div className="image-overlay" onClick={() => setSelectedImage(null)}>
    <img src={selectedImage} alt="Projet en grand" />
  </div>
)}
    </div>
  );
};

export default ProjectDetails;